import { flattenComponentTree } from './inline-components';

/**
 * Nome STAMPATO di un ingrediente: la denominazione legale (`labelName`) se
 * c'e', altrimenti il nome d'anagrafica. Unico punto di decisione per
 * cartellino, registro, menu, aggregazione allergeni e suggerimenti:
 * l'esenzione testuale dell'Allegato II e i controlli sulle denominazioni si
 * valutano su cio' che il cliente legge.
 *
 * Nessuna superficie distingue oggi la posizione (nodo annidato, radice del
 * cartellino, radice del preimballato).
 */
export function resolvePrintedName(ingredient: { name: string; labelName: string | null }): string {
  return ingredient.labelName ?? ingredient.name;
}

interface LinkableComponentRow {
  linkedIngredientId: string | null;
  children?: readonly LinkableComponentRow[];
}

/** `true` se almeno un componente dell'ingrediente, sotto-voci inline incluse, punta a un altro ingrediente. */
export function hasLinkedComponent(ingredient: {
  components: readonly LinkableComponentRow[];
}): boolean {
  return flattenComponentTree(ingredient.components).some(
    (component) => component.linkedIngredientId !== null,
  );
}
